import { DateTime } from "luxon";

export const remainingDaysInProject = (
  endDate: string | undefined | null,
): number | undefined => {
  if (!endDate) return undefined;
  const todayUtc = DateTime.utc().startOf("day");
  const endDateUtc = fromIsoToUtc(endDate).startOf("day");

  const difference = differenceInDays(todayUtc, endDateUtc);

  if (!isDifferenceValid(difference)) return undefined;

  return difference;
};

const fromIsoToUtc = (date: string) => DateTime.fromISO(date, { zone: "utc" });

const differenceInDays = (start: DateTime, end: DateTime) => {
  // NOTE: Diffing days and minutes so days is whole number and minutes is remainder (i.e. partial day) that we ignore.
  return end.diff(start, ["days", "minutes"]).days;
};

const isDifferenceValid = (difference: number) => {
  return difference > 0 && difference <= 30;
};
